import * as _ from 'lodash'
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Customer, esWB_Finished_Product, esWB_Product_Group} from "../PA.Core/PAdbSchema";
import {WB_CustomerRow, WB_FinishedProductRow, WB_PlanRow, WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";
import {IDateRange} from "../PA.Core/PA.Core.IF.Basic";
import {PASearch} from "../PA.Core/PASearch";
import {SourceCustomerService} from "../PA.MD.Services/SourceCustomerService";
import {PAusrContext} from "../PA.Core/PAusrContext";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {DateUtils} from "../PA.Core/Basic/Dates";

export class PlanningDataUtils {



  static getAllPlanningCustomers(aDbContext: PAdbContext): Promise<WB_CustomerRow[]> {

    return new Promise<WB_CustomerRow[]>((resolve, error) => {

      // TODO: Add condition to filter by Customer

      PASearch.find("vUI_Plan_Search", {},{},[], 0, ['WB_CUST_ID_PLANNING'])
        .then((results: any[]) => {
          // Get IDs
          if(_.isEmpty(results)){ resolve([]) }

          let arrWB_CUST_IDs = _.map(results, 'WB_CUST_ID_PLANNING')

          return aDbContext.findUsingCache(esWB_Customer, arrWB_CUST_IDs)
        })
        .then((wbCustomers: WB_CustomerRow[]) => {
          if(_.isEmpty(wbCustomers)){
            resolve([])
            return
          }

          resolve(wbCustomers)
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  static getSourceCustomers(aDbContext: PAdbContext, PlanningCustomers: WB_CustomerRow[]): Promise<WB_CustomerRow[]> {
    return new Promise<WB_CustomerRow[]>((resolve, error) => {
      let aSourceCustomerService = new SourceCustomerService();

      if(_.isEmpty(PlanningCustomers)){
        resolve([])
        return
      }
      let planningCustomerIds = _.map(PlanningCustomers, (aCstRw: WB_CustomerRow) => { return aCstRw.cif.WB_CUST_ID })
      aSourceCustomerService.getSrcCustIdsbyParent(planningCustomerIds)
        .then((results: number[]) => {
          if(_.isEmpty(results)){
            resolve([])
            return
          }

          return aDbContext.findUsingCache(esWB_Customer, results)
        })
        .then((wbSrcCustomers: WB_CustomerRow[]) => {
          if(_.isEmpty(wbSrcCustomers)){
            resolve([])
            return
          }

          resolve(wbSrcCustomers)
        })
        .catch((err) => {
          error(err)
        })
    })

  }

  static getAllProductGroups(aDbContext: PAdbContext): Promise<WB_ProductGroupRow[]> {

    // TODO:  Create view and use the search service to get distinct Planned Product Groups
    //return ASync.resolve([])

      var userContext: PAusrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
      let arrWBCustID = _.map(userContext.Customers, (aWBCustomer: WB_CustomerRow) => { return aWBCustomer.cif.WB_CUST_ID })

      return new Promise<WB_ProductGroupRow[]>((resolve, error) => {
          PASearch.find("vUI_Planned_PrdGrp", {}, {'WB_CUST_ID_PLANNING': {type: 'number'}}, [], 0, ['WB_PRDGRP_ID'])
              .then((results: any[]) => {
                  // Get IDs
                  if (_.isEmpty(results)) {
                      resolve([])
                  }

                  let arrWB_PrdGrp_IDs = _.map(results, 'WB_PRDGRP_ID')

                  return aDbContext.findUsingCache(esWB_Product_Group, arrWB_PrdGrp_IDs)
              })
              .then((wbProductGroups: WB_ProductGroupRow[]) => {
                  if (_.isEmpty(wbProductGroups)) {
                      resolve([])
                      return
                  }

                  resolve(wbProductGroups)
              })
              .catch((err) => {
                  error(err)
              })
      })
  }

  static getPlanProductGroups(aDbContext: PAdbContext, Plans: WB_PlanRow[]): Promise<WB_ProductGroupRow[]> {

    return new Promise<WB_ProductGroupRow[]>((resolve, error) => {

      const userContext: PAusrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
      let   arrWBCustID = _.map(userContext.Customers, (aWBCustomer: WB_CustomerRow) => { return aWBCustomer.cif.WB_CUST_ID })

      let arrWB_PLAN_IDs = _.map(Plans, (aWBPlan: WB_PlanRow) => { return aWBPlan.cif.WB_PLAN_ID })
      PASearch.find("vUI_Plan_PrdGrp",
        {'WB_CUST_ID_PLANNING': {inq: arrWBCustID }, 'WB_PLAN_ID': {inq: arrWB_PLAN_IDs}},
        {WB_CUST_ID_PLANNING: {type: 'number'},
                            WB_PLAN_ID: {type: 'number'},
                            WB_PRDGRP_ID: {type: 'number'}},
        [],
        0,
        ['WB_PRDGRP_ID'])
        .then((results: any[]) => {
          // Get IDs
          if (_.isEmpty(results)) {
            resolve([])
          }

          let arrWB_PrdGrp_IDs = _.map(results, 'WB_PRDGRP_ID')

          return aDbContext.findUsingCache(esWB_Product_Group, arrWB_PrdGrp_IDs)
        })
        .then((wbProductGroups: WB_ProductGroupRow[]) => {
          if (_.isEmpty(wbProductGroups)) {
            resolve([])
            return
          }
          resolve(wbProductGroups)
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  static getPlanEventIds(Plans: WB_PlanRow[], bIncludePGFilter?: boolean, ProductGroups?: WB_ProductGroupRow[]): Promise<number[]> {

    return new Promise<number[]>((resolve, error) => {

      if (_.isEmpty(Plans)){
        resolve([])
        return
      }

      // The following logic to determine the condition is the same as the processQueue logic..

      let arrWBPlanIds = _.map(Plans, (aWBPlan: WB_PlanRow) => { return aWBPlan.cif.WB_PLAN_ID })

      if (_.isEmpty(arrWBPlanIds)) {
        arrWBPlanIds = [-99999]
      }

      let condition: any = {WB_PLAN_ID: {inq: arrWBPlanIds}}

      let arrWBPrdGrpIds: number[] = []
      if(bIncludePGFilter && !_.isEmpty(ProductGroups)){
        arrWBPrdGrpIds = _.map(ProductGroups, (aPrdGrpRow: WB_ProductGroupRow) => {
          return aPrdGrpRow.cif.WB_PRDGRP_ID
        })
      }


      if (bIncludePGFilter) {
        if (_.isEmpty(arrWBPrdGrpIds)) {
          arrWBPrdGrpIds = [-99999]
        }

        condition = {and: [condition, {WB_PRDGRP_ID: {inq: arrWBPrdGrpIds}}]}
      }

      PASearch.find('vWB_Events_By_Plan_PrdGrp',
        {where: condition},
        {
          WB_PRDGRP_ID: {type: 'number'},
          WB_PLAN_ID: {type: 'number'},
          WB_EVT_ID: {type: 'number'}
        },
        [],
        0,
        ['WB_EVT_ID', 'WB_PLAN_ID'])
        .then((arrWBEventIdsFound: { WB_EVT_ID: number, WB_PLAN_ID: number }[]) => {
          if (!_.isArray(arrWBEventIdsFound)) {
            resolve([])
          }
          let returnValue: number[] = []
          _.forEach(arrWBEventIdsFound, (aRow) => {
            returnValue.push(aRow.WB_EVT_ID)
          })
          resolve(returnValue)
        })
        .catch((err) => {
          error(err)
        })

    })

  }

  static getAllProducts(aDbContext: PAdbContext): Promise<WB_FinishedProductRow[]> {
    return new Promise<WB_FinishedProductRow[]>((resolve, error) => {
      PASearch.find("vUI_Plan_Prd", {}, {}, [], 0, ['WB_PROD_ID'])
        .then((results: any[]) => {
          if (_.isEmpty(results)) {
            resolve([])
          }

          let arrWB_Prd_IDs = _.map(results, 'WB_PROD_ID')

          return aDbContext.findUsingCache(esWB_Finished_Product, arrWB_Prd_IDs)

        })
        .then((wbProducts: WB_FinishedProductRow[]) => {
          if (_.isEmpty(wbProducts)) {
            resolve([])
            return
          }

          resolve(wbProducts)
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  static getProducts(aDbContext: PAdbContext, PlanningCustomers: WB_CustomerRow[], ProductGroups: WB_ProductGroupRow[]): Promise<WB_FinishedProductRow[]> {
    return new Promise<WB_FinishedProductRow[]>((resolve, error) => {
      let condition:any = {}
      if(!_.isEmpty(PlanningCustomers)){
        condition.WB_CUST_ID_PLANNING = {inq: _.map(PlanningCustomers, (aWBCst: WB_CustomerRow) => { return aWBCst.cif.WB_CUST_ID })}
      }
      condition.WB_PRDGRP_ID = {inq: _.map(ProductGroups, (aWBPrdGrp) => { return aWBPrdGrp.cif.WB_PRDGRP_ID })}

      PASearch.find("vUI_Plan_Prd",  condition, {WB_CUST_ID_PLANNING: {type: "number"},WB_PRDGRP_ID: {type: "number"}},[], 0, ['WB_PROD_ID'])
        .then((results: any[]) => {
          if (_.isEmpty(results)) {
            resolve([])
          }

          let arrWB_Prd_IDs = _.map(results, 'WB_PROD_ID')

          return aDbContext.findUsingCache(esWB_Finished_Product, arrWB_Prd_IDs)

        })
        .then((wbProducts: WB_FinishedProductRow[]) => {
          if (_.isEmpty(wbProducts)) {
            resolve([])
            return
          }

          resolve(wbProducts)
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  static getDateBounds(aDbContext: PAdbContext): Promise<{InStore: IDateRange, Shipment: IDateRange}> {
    return new Promise<{InStore: IDateRange, Shipment: IDateRange}>((resolve, error) => {
      //
      PASearch.find("vUI_Plan_Periods", {}, {}, [], 0, [])
        .then((results: any[]) => {
          //
          let InStoreRange: IDateRange = {StartDt: undefined, EndDt: undefined}
          let ShipmentRange: IDateRange = {StartDt: undefined, EndDt: undefined}
          if(_.isEmpty(results)){ resolve({InStore: InStoreRange, Shipment: ShipmentRange}) }

          _.forEach(results, (aRow:any) => {
            let InStore_Start = DateUtils.convertFromSAPBW(aRow.INSTORE_START_DT)
            let InStore_End = DateUtils.convertFromSAPBW(aRow.INSTORE_END_DT)
            let Shipment_Start = DateUtils.convertFromSAPBW(aRow.SHIPMENT_START_DT)
            let Shipment_End = DateUtils.convertFromSAPBW(aRow.SHIPMENT_END_DT)

            InStoreRange = DateUtils.RangeUnion(InStoreRange, {StartDt: InStore_Start, EndDt: InStore_End})
            ShipmentRange = DateUtils.RangeUnion(ShipmentRange, {StartDt: Shipment_Start, EndDt: Shipment_End})
          })

          resolve({InStore: InStoreRange, Shipment: ShipmentRange})

        })
        .catch((err) => {
          error(err)
        })

    })
  }



}


